"use strict";
exports.__esModule = true;
exports.useCallback = exports.useRef = exports.useEffect = exports.useState = exports["default"] = void 0;
var React = window.MTBlockEditor.React;
exports["default"] = React;
var useState = React.useState, useEffect = React.useEffect, useRef = React.useRef, useCallback = React.useCallback;
exports.useState = useState;
exports.useEffect = useEffect;
exports.useRef = useRef;
exports.useCallback = useCallback;
